import useSidePanel from './hooks/useSidePanel';

function withSidePanel(Component) {
  return (props) => {
    const { state, dispatch } = useSidePanel();
    return (
      <Component
        sidePanelState={state}
        sidePanelDispatch={dispatch}
        {...props}
      />
    );
  };
}

export default withSidePanel;
